/**
 * The top bar that only exists below `md`.
 *
 * When the sidebar becomes a drawer it takes its head with it — and with it the
 * only way to open the drawer, and the theme switch. Both come back here, which
 * is why this bar carries the wordmark too: it is the app's masthead at that
 * width, not a decoration.
 */

import { Menu } from "lucide-react";
import { IconAction } from "./IconAction.tsx";
import { ThemeToggle } from "./ThemeToggle.tsx";

interface MobileBarProps {
  readonly onOpenNav: () => void;
}

export function MobileBar({ onOpenNav }: MobileBarProps) {
  return (
    <header className="flex items-center gap-2 border-b bg-background px-gutter py-2 font-sans md:hidden">
      <IconAction label="Show conversations" onClick={onOpenNav}>
        <Menu />
      </IconAction>

      <span className="flex-1 font-serif text-xl">sZero</span>

      <ThemeToggle />
    </header>
  );
}
